import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useCommonApi() {
    const callApi = useApiCall();

    const GetCountryList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.COMMON.GET_COUNTRY, data, onSuccess, onError);
    };

    const GetCountyList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.COMMON.GET_COUNTY, data, onSuccess, onError);
    };

    const GetStateList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.COMMON.GET_STATE, data, onSuccess, onError);
    };

    const GetCityList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.COMMON.GET_CITY, data, onSuccess, onError);
    };

    const GetCurrencyList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.COMMON.GET_CURRENCY, data, onSuccess, onError);
    }

    const GetTimezones = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.COMMON.GET_TIMEZONES, data, onSuccess, onError);
    }

    return {
        GetCountryList,
        GetCountyList,
        GetStateList,
        GetCityList,
        locationSearch: apiCaller(callApi, SAGA_ACTIONS.COMMON.LOCATION_SEARCH),
        lookupValues: apiCaller(callApi, SAGA_ACTIONS.COMMON.LOOKUP_VALUES),
        uploadImage: apiCaller(callApi, SAGA_ACTIONS.STORAGE.UPLOAD_IMAGE),
        GetCurrencyList,
        GetTimezones,
    };
}
